import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import Loader from "../Loader";
import "./profile.scss";
import usercalls from "../../Axios";
import Sidebar from "../SideBar/SideBar";
import { Box, TextField, Typography, Modal } from "@mui/material";
import Grid from "@mui/material/Grid";

import "./profile.scss";

import bankcard from "../../Img/bankcard.svg";
import consts from "../../constant";
import Footernew from "../Footer/Footernew";

export default function Profile() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const path = usercalls();
  const [profileData, setProfileData] = useState({});
  const [load, setLoad] = useState(false);

  const getProfile = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/users/get_profile`;

      const data = await path.getCallWithToken({ url });
      const result = await data.json();
      if (result.success) {
        // console.log(result?.result, "resulkt");
        setProfileData(result.result);
        setLoad(false);
      } else {
        setProfileData({});
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log("🚀 ~ getProfile ~ error", error);
      setLoad(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);
  return (
    <div className="menu-responsive">
      <div>
        <Header />
        {load && <Loader />}
        <div className="main_flx">
          <Sidebar />
          <div style={{ width: "100%" }}>
            <div className="abvbar split_half">
              <h6>User Profile</h6>
            </div>
            <Grid container spacing={4} className=" mt-30" sx={{ py: 2, px: 6, alignItems: 'center', justifyContent: 'flex-start' }}>
              <Grid item
                xs={12}
                sm={12}
                md={5}
                lg={5}
                xl={5}
                className="box_bdr prf_info mb-10"
              >
                <div className="mb-10" style={{ marginBottom: '50px' }}>
                  <h2>Profile Info</h2>
                  <p className="email" style={{ margin: "0px !important" }}>
                    Email ID : <span>{profileData?.email}</span>{" "}
                  </p>
                  <p className="ref">
                    Referral ID :{" "}
                    <span> {profileData?.referral_code} </span>
                  </p>
                </div>
                <div>

                  <h2>Personal Details</h2>
                  <p className="name" style={{ margin: "0px !important" }}>
                    Name :{" "}
                    <span>{profileData?.name}</span>
                  </p>
                  <p className="numberr">
                    Mobile Number:{" "}
                    <span> {profileData?.phone ? profileData?.phone : "-"}</span>
                  </p>
                  <p className="countrry">
                    Country:{" "}
                    <span>{profileData?.country}</span>
                  </p>
                </div>

              </Grid>
              <Grid item
                xs={12}
                sm={12}
                md={1}
                lg={1}
                xl={1}

              ></Grid>

              {/* <Grid
                         
                          item
                          xs={12}
                          sm={12}
                          md={5}
                          lg={5}
                          xl={5}
                          className="box_bdr per_det mb-10"
                         sx={{minHeight:'260px'}}
                        >
                          <h2>Personal Details</h2>
                          <div className="flx">
                            <div>Name</div>
                            <div>{profileData?.name}</div>
                          </div>
                          <div className="flx">
                            <div>Mobile Number</div>
                            <div>
                              {profileData?.phone ? profileData?.phone : "-"}
                            </div>
                          </div>
                          <div className="flx">
                            <div>Country</div>
                            <div>{profileData?.country}</div>
                          </div>
                        </Grid>  */}




              {/* <div
                      className="display-2 flex-wrap"
                      style={{ gap: '10px', margin: '10px 0' }}
                    >
                      <h5 style={{ margin: '0' }}>Bank Details</h5>
                      <Link
                        to={'#'}
                        onClick={handleOpen}
                        className="org_btn sm_txt"
                        style={{ display: 'inline-block' }}
                      >
                        Add Bank
                      </Link>
                    </div>
                    <div className="box_bdr per_det">
                      <Grid
                        container
                        spacing={2}
                        sx={{ justifyContent: 'space-between' }}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={4}
                          xl={4}
                          sx={{ margin: 'auto 0' }}
                        >
                          <div className="flx">
                            <div>Bank Name</div>
                            <div>State Bank Of India</div>
                          </div>
                          <div className="flx">
                            <div> Branch Name</div>
                            <div>Madurai</div>
                          </div>
                          <div className="flx">
                            <div> IFSC Code</div>
                            <div>SBIN0002266</div>
                          </div>
                          <div className="flx">
                            <div> Account Number</div>
                            <div>1234556879956</div>
                          </div>
                          <div className="flx">
                            <div> Account holder Name</div>
                            <div>John</div>
                          </div>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={4}
                          xl={4}
                          sx={{ margin: 'auto 0' }}
                        >
                          <Box sx={{ textAlign: { lg: 'right' } }}>
                            <div class="card-container">
                              <div class="card-box">
                                <div class="card-head">
                                  <div class="card-chip">
                                    <img width="40" height="40" src="https://img.icons8.com/offices/50/sim-card-chip.png" alt="sim-card-chip" />
                                  </div>
                                  <div class="card-logo">
                                    <img width="60" height="40" src="https://cdn-icons-png.flaticon.com/128/14035/14035060.png" alt="sim-card-chip" />
                                  </div>
                                </div>
                                <div class="card-number-row">
                                  <span>123 455 687 9956</span>
                                </div>
                                <div class="card-details">
                                  <div class="card-holder-col">
                                    <span class="card-holder-title">CARD HOLDER</span>
                                    <span class="card-holder-name">John</span>
                                  </div>
                                  <div class="card-date-col">
                                    <span class="card-date-title">IFSC Code</span>
                                    <span class="card-date-sub">SBIN0002266</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </Box>
                        </Grid>
                      </Grid>
                    </div> */}

              {/* <Grid
                          
 item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={5}
                          xl={5}
                          className="kyc_box box_bdr"
                                        sx={{mt:5}}      >
                        
                            <h6>KYC Verified</h6>
                            <p>
                              Get increased limits and advanced features by
                              providing a bit more profile information
                            </p>
                            <div className="display-2">
                              <Link
                                to={"/Kycverify"}
                                className="org_btn sm_txt"
                                style={{ display: "inline-block" }}
                              >
                                Get Started
                              </Link>
                              <svg
                                className="fill_dark_to_white"
                                width="58"
                                height="59"
                                viewBox="0 0 58 59"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.1983 6.0332C13.2867 6.0332 11.4181 6.60005 9.82866 7.66206C8.23924 8.72408 7.00045 10.2336 6.26892 11.9996C5.53739 13.7657 5.34599 15.709 5.71892 17.5839C6.09185 19.4587 7.01236 21.1809 8.36405 22.5325C9.71573 23.8842 11.4379 24.8047 13.3127 25.1777C15.1876 25.5506 17.1309 25.3592 18.897 24.6277C20.663 23.8961 22.1725 22.6573 23.2345 21.0679C24.2965 19.4785 24.8634 17.6099 24.8634 15.6983C24.8604 13.1359 23.8412 10.6792 22.0293 8.8673C20.2174 7.05538 17.7607 6.03615 15.1983 6.0332ZM20.394 14.0677L13.9978 20.3263C13.8596 20.4614 13.6946 20.566 13.5135 20.6334C13.3324 20.7007 13.1391 20.7293 12.9462 20.7173C12.7534 20.7052 12.5652 20.6529 12.3938 20.5635C12.2225 20.4742 12.0717 20.3499 11.9514 20.1987L8.96661 16.4435C8.73981 16.1567 8.636 15.7917 8.67795 15.4285C8.7199 15.0652 8.90418 14.7335 9.19039 14.5059C9.47659 14.2784 9.84135 14.1737 10.2047 14.2147C10.568 14.2557 10.9002 14.4391 11.1285 14.7248L13.1609 17.2817L18.4627 12.0937C18.5923 11.9669 18.7456 11.8668 18.9139 11.7993C19.0822 11.7317 19.2621 11.698 19.4434 11.6999C19.6248 11.7019 19.8039 11.7396 19.9707 11.8108C20.1374 11.882 20.2885 11.9854 20.4153 12.115C20.5422 12.2446 20.6422 12.398 20.7098 12.5662C20.7773 12.7345 20.8111 12.9145 20.8091 13.0958C20.8071 13.2771 20.7694 13.4563 20.6982 13.623C20.627 13.7898 20.5236 13.9409 20.394 14.0677Z"
                                  fill="#566FFF"
                                />
                                <path
                                  d="M27.8918 24.0344C29.9568 20.8906 30.7823 17.0925 30.2084 13.3752C29.6346 9.6579 27.7022 6.28559 24.7853 3.91088C21.8684 1.53616 18.1743 0.327861 14.4178 0.519811C10.6614 0.71176 7.10966 2.29031 4.44998 4.94998C1.79031 7.60966 0.21176 11.1614 0.0198106 14.9178C-0.172139 18.6743 1.03616 22.3684 3.41088 25.2853C5.78559 28.2022 9.1579 30.1346 12.8752 30.7084C16.5925 31.2823 20.3906 30.4568 23.5344 28.3918L27.2455 29.4525C27.4822 29.5197 27.7326 29.5225 27.9708 29.4605C28.2089 29.3986 28.4262 29.2742 28.6002 29.1002C28.7743 28.9262 28.8986 28.7089 28.9606 28.4707C29.0225 28.2326 29.0197 27.9822 28.9525 27.7455L27.8918 24.0344ZM15.1983 28.1249C12.7406 28.1249 10.338 27.3961 8.2945 26.0306C6.25097 24.6652 4.65823 22.7244 3.71769 20.4537C2.77716 18.1831 2.53107 15.6845 3.01055 13.274C3.49003 10.8635 4.67355 8.64931 6.41143 6.91143C8.14931 5.17355 10.3635 3.99003 12.774 3.51055C15.1845 3.03107 17.6831 3.27716 19.9537 4.21769C22.2244 5.15823 24.1652 6.75097 25.5306 8.7945C26.8961 10.838 27.6249 13.2406 27.6249 15.6983C27.6211 18.9929 26.3107 22.1515 23.9811 24.4811C21.6515 26.8107 18.4929 28.1211 15.1983 28.1249Z"
                                  fill="#566FFF"
                                />
                                <path
                                  d="M30.8108 50.6515C30.8075 50.8348 30.8409 51.017 30.9088 51.1874C30.9767 51.3577 31.0779 51.5128 31.2064 51.6437C31.335 51.7745 31.4883 51.8784 31.6574 51.9494C31.8265 52.0203 32.0081 52.0569 32.1915 52.0569H50.1773C50.3607 52.0569 50.5423 52.0203 50.7114 51.9494C50.8805 51.8784 51.0338 51.7745 51.1624 51.6437C51.2909 51.5128 51.3921 51.3577 51.46 51.1874C51.528 51.017 51.5613 50.8348 51.5581 50.6515C51.5424 48.7403 51.0193 46.8677 50.0422 45.2252C49.0651 43.5827 47.6692 42.2293 45.9972 41.3035C47.2988 40.299 48.2535 38.9125 48.7276 37.3382C49.2016 35.7639 49.1712 34.0808 48.6406 32.5246C48.11 30.9685 47.1058 29.6174 45.7687 28.6606C44.4316 27.7039 42.8287 27.1895 41.1846 27.1895C39.5405 27.1894 37.9376 27.7039 36.6005 28.6606C35.2635 29.6173 34.2593 30.9684 33.7286 32.5246C33.198 34.0807 33.1676 35.7638 33.6416 37.3381C34.1156 38.9124 35.0703 40.299 36.3719 41.3034C34.6999 42.2292 33.3038 43.5826 32.3267 45.2251C31.3496 46.8676 30.8264 48.7403 30.8108 50.6515ZM41.1846 29.9653C42.0203 29.9656 42.8431 30.1706 43.5811 30.5625C44.3192 30.9543 44.9499 31.5211 45.4183 32.2131C44.8571 32.7725 44.1912 33.2159 43.4586 33.5179C42.726 33.8199 41.9411 33.9745 41.1487 33.9731H36.1928C36.446 32.8374 37.0782 31.8218 37.9855 31.0933C38.8928 30.3649 40.0211 29.9671 41.1846 29.9653ZM36.348 36.7345H41.1487C42.9979 36.7398 44.8012 36.1594 46.3002 35.0767L46.3004 35.081C46.2989 36.4358 45.7607 37.7348 44.8035 38.6936C43.8464 39.6524 42.5483 40.1929 41.1935 40.1967H41.1758C40.111 40.1932 39.0738 39.8578 38.2085 39.2373C37.3432 38.6168 36.6929 37.7419 36.348 36.7345ZM40.719 42.9581H41.6503C45.0801 42.9581 47.9917 45.6944 48.656 49.2955H33.7129C34.3772 45.6944 37.2888 42.9581 40.719 42.9581Z"
                                  fill="#1E2329"
                                />
                                <path
                                  d="M8.37487 37.7908H26.7846C27.1507 37.7908 27.5019 37.6453 27.7609 37.3863C28.0198 37.1274 28.1653 36.7762 28.1653 36.41C28.1653 36.0438 28.0198 35.6926 27.7609 35.4337C27.5019 35.1748 27.1507 35.0293 26.7846 35.0293H8.37487C8.00868 35.0293 7.65748 35.1748 7.39855 35.4337C7.13961 35.6926 6.99414 36.0438 6.99414 36.41C6.99414 36.7762 7.13961 37.1274 7.39855 37.3863C7.65748 37.6453 8.00868 37.7908 8.37487 37.7908Z"
                                  fill="#1E2329"
                                />
                                <path
                                  d="M8.37487 44.6931H26.7846C26.9659 44.6931 27.1454 44.6574 27.3129 44.588C27.4805 44.5186 27.6327 44.4169 27.7609 44.2887C27.8891 44.1605 27.9908 44.0083 28.0602 43.8407C28.1296 43.6732 28.1653 43.4937 28.1653 43.3124C28.1653 43.131 28.1296 42.9515 28.0602 42.784C27.9908 42.6165 27.8891 42.4643 27.7609 42.336C27.6327 42.2078 27.4805 42.1061 27.3129 42.0367C27.1454 41.9674 26.9659 41.9316 26.7846 41.9316H8.37487C8.00867 41.9316 7.65748 42.0771 7.39855 42.336C7.13961 42.595 6.99414 42.9462 6.99414 43.3124C6.99414 43.6786 7.13961 44.0298 7.39855 44.2887C7.65748 44.5476 8.00867 44.6931 8.37487 44.6931Z"
                                  fill="#1E2329"
                                />
                                <path
                                  d="M8.37487 51.5974H26.7846C27.1507 51.5974 27.5019 51.4519 27.7609 51.193C28.0198 50.934 28.1653 50.5829 28.1653 50.2167C28.1653 49.8505 28.0198 49.4993 27.7609 49.2403C27.5019 48.9814 27.1507 48.8359 26.7846 48.8359H8.37487C8.00868 48.8359 7.65748 48.9814 7.39855 49.2403C7.13961 49.4993 6.99414 49.8505 6.99414 50.2167C6.99414 50.5829 7.13961 50.934 7.39855 51.193C7.65748 51.4519 8.00868 51.5974 8.37487 51.5974Z"
                                  fill="#1E2329"
                                />
                                <path
                                  d="M54.7786 20.7617H33.4002C33.0341 20.7617 32.6829 20.9072 32.4239 21.1661C32.165 21.4251 32.0195 21.7763 32.0195 22.1424C32.0195 22.5086 32.165 22.8598 32.4239 23.1188C32.6829 23.3777 33.0341 23.5232 33.4002 23.5232H54.7786C54.9006 23.5233 55.0176 23.5718 55.1039 23.6581C55.1902 23.7444 55.2387 23.8614 55.2388 23.9834V55.2799C55.2387 55.4019 55.1902 55.5189 55.1039 55.6052C55.0176 55.6915 54.9006 55.74 54.7786 55.7401H3.23146C3.10942 55.74 2.99241 55.6915 2.90611 55.6052C2.81982 55.5189 2.7713 55.4019 2.77122 55.2799V29.2016C2.77122 29.0203 2.73551 28.8408 2.66612 28.6733C2.59673 28.5057 2.49503 28.3535 2.36681 28.2253C2.2386 28.0971 2.08639 27.9954 1.91887 27.926C1.75136 27.8566 1.57181 27.8209 1.39049 27.8209C1.20917 27.8209 1.02963 27.8566 0.862111 27.926C0.694594 27.9954 0.542383 28.0971 0.414171 28.2253C0.285959 28.3535 0.184255 28.5057 0.114867 28.6733C0.0454792 28.8408 0.00976562 29.0203 0.00976563 29.2016V55.2799C0.0107985 56.134 0.350558 56.9529 0.954519 57.5568C1.55848 58.1608 2.37733 58.5005 3.23146 58.5016H54.7786C55.6327 58.5005 56.4516 58.1608 57.0555 57.5568C57.6595 56.9529 57.9993 56.134 58.0003 55.2799V23.9834C57.9993 23.1293 57.6595 22.3104 57.0555 21.7065C56.4516 21.1025 55.6327 20.7628 54.7786 20.7617Z"
                                  fill="#1E2329"
                                />
                              </svg>
                            </div>
                         
                        </Grid> */}

            </Grid>


          </div>
        </div>

        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              class="boxstyle"
              style={{
                border: "1px solid #e7e7e7",
                borderRadius: "10px;",
                boxShadow: "none",
              }}
            >
              <Typography id="modal-modal-title" variant="h6" component="h2">
                <div className="otp_flx">
                  <span
                    className="otp"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
                      paddingBottom: "5px",
                    }}
                  >
                    Add Bank{" "}
                  </span>
                  <svg
                    style={{ position: "absolute", right: "35px" }}
                    onClick={handleClose}
                    className="cursor-pointer fill_dark_to_white"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.75 2.25L2.25 15.75"
                      stroke="black"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.75 15.75L2.25 2.25"
                      stroke="black"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </Typography>
              <br />
              <label className="grey_label">Bank Name</label>
              <div className="input_box mb-20 mt-10">
                <TextField
                  type="text"
                  fullWidth
                  placeholder="Enter Bank Name"
                  sx={{
                    "& .MuiInputBase-formControl": {
                      borderRadius: "5px",
                      backgroundColor: "transparent",
                    },
                    "& .MuiInputBase-input": {
                      padding: "11px 20px",
                      border: "0",
                      fontSize: "16px",
                      fontWeight: "400",
                      textAlign: "left",
                    },
                    "& fieldset": { border: "1px solid #818898 !important" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "black",
                      fontSize: "15px",
                    },
                  }}
                />
              </div>
              <label className="grey_label">IFSC Code</label>
              <div className="input_box mb-20 mt-10">
                <TextField
                  type="text"
                  fullWidth
                  placeholder="Enter IFSC Code"
                  sx={{
                    "& .MuiInputBase-formControl": {
                      borderRadius: "5px",
                      backgroundColor: "transparent",
                    },
                    "& .MuiInputBase-input": {
                      padding: "11px 20px",
                      border: "0",
                      fontSize: "16px",
                      fontWeight: "400",
                      textAlign: "left",
                    },
                    "& fieldset": { border: "1px solid #818898 !important" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "black",
                      fontSize: "15px",
                    },
                  }}
                />
              </div>
              <label className="grey_label">Branch Name</label>
              <div className="input_box mb-20 mt-10">
                <TextField
                  type="text"
                  fullWidth
                  placeholder="Enter Branch Name"
                  sx={{
                    "& .MuiInputBase-formControl": {
                      borderRadius: "5px",
                      backgroundColor: "transparent",
                    },
                    "& .MuiInputBase-input": {
                      padding: "11px 20px",
                      border: "0",
                      fontSize: "16px",
                      fontWeight: "400",
                      textAlign: "left",
                    },
                    "& fieldset": { border: "1px solid #818898 !important" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "black",
                      fontSize: "15px",
                    },
                  }}
                />
              </div>
              <label className="grey_label">Account Number</label>
              <div className="input_box mb-20 mt-10">
                <TextField
                  type="text"
                  fullWidth
                  placeholder="Enter Account Number"
                  sx={{
                    "& .MuiInputBase-formControl": {
                      borderRadius: "5px",
                      backgroundColor: "transparent",
                    },
                    "& .MuiInputBase-input": {
                      padding: "11px 20px",
                      border: "0",
                      fontSize: "16px",
                      fontWeight: "400",
                      textAlign: "left",
                    },
                    "& fieldset": { border: "1px solid #818898 !important" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "black",
                      fontSize: "15px",
                    },
                  }}
                />
              </div>
              <label className="grey_label">Account holder Name</label>
              <div className="input_box mb-20 mt-10">
                <TextField
                  type="text"
                  fullWidth
                  placeholder="Enter Account holder Name"
                  sx={{
                    "& .MuiInputBase-formControl": {
                      borderRadius: "5px",
                      backgroundColor: "transparent",
                    },
                    "& .MuiInputBase-input": {
                      padding: "11px 20px",
                      border: "0",
                      fontSize: "16px",
                      fontWeight: "400",
                      textAlign: "left",
                    },
                    "& fieldset": { border: "1px solid #818898 !important" },
                    "& .MuiInputBase-input::placeholder": {
                      color: "black",
                      fontSize: "15px",
                    },
                  }}
                />
              </div>

              <Link
                to={"#"}
                className="org_btn sm_txt"
                style={{
                  padding: "12px 60px",
                  marginBottom: "10px",
                  display: "block",
                  fontWeight: "700",
                  margin: "0 auto",
                  width: "75%",
                  textAlign: "center",
                }}
              >
                CONFIRM
              </Link>
            </Box>
          </Modal>
        </div>
      </div>
      <Footernew />
    </div>
  );
}
